import styled from '@emotion/styled'
import { CrudActions, SpreadsheetMapping } from 'api'
import { Locale, Translation } from 'locale'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Groupbox, ModalContent, ModalFooter, ModalWindow } from 'view/components/panels'
import { ParseResultPanel } from '../upload'
import { MappingDialogFooter } from '../upload/mappingDialog/MappingDialogFooter'
import { CollateralBasketAllocationMappingDialogColumns } from './CollateralBasketAllocationMappingDialogColumns'
import { CollateralAllocationParseResult, CollateralAllocationSpreadsheetParseParams } from './collateralBasketAllocationUploadParse'
import { TextInputField } from 'view/components/inputs'

interface CollateralBasketAllocationMappingDialogProps {
  title: string
  mapping: SpreadsheetMapping
  parseResult: CollateralAllocationParseResult
  collateralAllocationParser: (params: CollateralAllocationSpreadsheetParseParams) => CollateralAllocationParseResult
  onClose?: (mapping?: SpreadsheetMapping) => unknown
}

const Content = styled(ModalContent)`
  width: 600px;
`

export const CollateralBasketAllocationMappingDialog: React.FC<CollateralBasketAllocationMappingDialogProps> = props => {
  const { onClose, title, collateralAllocationParser } = props
  const [mapping, setMapping] = useState(props.mapping)
  const [parseResult, setParseResult] = useState(props.parseResult)

  const dispatch = useDispatch()

  const handleSave = () => {
    dispatch(CrudActions.spreadsheetMappingUpsert(mapping))
    if (onClose) {
      onClose(mapping)
    }
  }

  const handleClose = () => {
    if (onClose) {
      onClose()
    }
  }

  const handleUpdateColumns = (updatedMapping: SpreadsheetMapping) => {
    setMapping(updatedMapping)
    setParseResult(
      collateralAllocationParser({ rowData: parseResult.rows, filename: parseResult.filename, spreadsheetMapping: updatedMapping })
    )
  }

  const handleUpdateName = (name: string) => {
    setMapping({ ...mapping, name })
  }

  return (
    <ModalWindow title={title}>
      <Content>
        <Groupbox title={props.parseResult.filename}>
          <ParseResultPanel
            parseResult={parseResult}
            itemField={'pendingAllocations'}
            successMessage={Translation.SC_COLLATERAL_BASKET_ALLOCATION_SPREADSHEET_SUCCESS}
            errorMessage={Translation.SC_COLLATERAL_BASKET_ALLOCATION_SPREADSHEET_ERROR}
            errorNarrative={Translation.SC_UPLOAD_ERROR_NARRATIVE_MAPPING}
          />
        </Groupbox>
        <Groupbox>
          <CollateralBasketAllocationMappingDialogColumns mapping={mapping} parseResult={parseResult} onUpdate={handleUpdateColumns} />
        </Groupbox>
        <Groupbox>
          <TextInputField label={Locale.translate(Translation.SC_DISPLAY_NAME)} value={mapping.name} onUpdate={handleUpdateName} />
        </Groupbox>
      </Content>
      <ModalFooter>
        <MappingDialogFooter handleClose={handleClose} handleSave={handleSave} canSave={true} />
      </ModalFooter>
    </ModalWindow>
  )
}
